import * as actions from './consts'
import { entitySetter } from '../utils'

const ACTION_HANDLERS = {
  [actions.FLOWS_LOAD_SUCCESS]: (state, { flows = [] }) => {
    return entitySetter(state, flows);
  },
  [actions.FLOW_LOAD_SUCCESS]: (state, { flow }) => {
    return entitySetter(state, flow);
  },
  [actions.FLOW_CREATE_SUCCESS]: (state, { flow }) => {
    return entitySetter(state, flow);
  },
  [actions.FLOW_STEP_NEW_SUCCESS]: (state, { flowId, step }) => {
    const s = {...state};
    s[flowId] = {...s[flowId]};
    s[flowId].flow_nodes = {...s[flowId].flow_nodes};
    s[flowId].flow_nodes[step.id] = step

    return s;
  },
}

const initialState = {
}

export default function flowReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}
